export function processTitle(title: string) {
  if (title && title.startsWith('Nobel® by Jensen - det lille ekstra')) {
    return (
      <span className="font-garamond tracking-wide">
        <span className="font-semibold">Nobel® by Jensen</span> - det lille
        ekstra!
      </span>
    );
  }
  return title;
}
